import React, { Component } from 'react';
import {Helmet} from 'react-helmet';

import Api from './../../configs/api';
import HttpUtil from './../../utils/http';

import Dashboard from './../../pages/dashboard';


class CombinationHome extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render () {
    let innerContent = (
      <div className="row">
        <div className="col-lg-3">
          <div className="card shadow mb-4">
            <a href="/combination/tithi" className="card-body">
              Tithi Combination
            </a>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="card shadow mb-4">
            <a href="/combination/event" className="card-body">
              Festival Combination
            </a>
          </div>
        </div>
      </div>
    );

    let parentProps = {
      title: '',
      header: <Header />,
      content: innerContent,
      footer: <Footer />,
    };

    return (
      <Dashboard {...parentProps} />
    )
  }
}

const Header = (props) => {
  return (
    <Helmet>
      {/*Header Code Here*/}
      <title>Validation Home - Nirwanji</title>
    </Helmet>
  )
}

const Footer = (props) => {
  return (
    <div>
      {/* Footer Code Here */}
    </div>
  )
}

export default CombinationHome;
